module.exports = __webpack_public_path__ + "static/images/challenge.9b942d45b6fa4544d76df80d67b4f461.jpg";